





































import Vue, { PropType } from "vue";
import {
  PrintTypeInterface,
  typeTable,
  PrintTypes
} from "@/model/components/PrintTypeInterface.ts";

export default Vue.extend({
  name: "PrintTypeButton",

  props: {
    printType: {
      type: Object as PropType<PrintTypeInterface>,
      required: true
    },
    formColClass: {
      type: String,
      required: true
    }
  },

  computed: {
    typeTable() {
      const obj = {
        monochrome: {},
        color: {}
      };
      obj["color"] = typeTable.color;
      obj["monochrome"] = typeTable.monochrome;
      return obj;
    },
    radioPrefix(): Function {
      return (
        frontSideKey: typeof PrintTypes["COLOR" | "MONOCHROME" | "NONE"],
        index: number
      ): number => (frontSideKey === "monochrome" ? index + 1 : index + 4);
    }
  },

  methods: {
    updatePrintType(
      frontSideKey: typeof PrintTypes,
      backSideKey: typeof PrintTypes,
      text: string,
      type: string
    ): void {
      this.$emit("updatePrintType", {
        text: text,
        type: type,
        frontSideColor: frontSideKey,
        backSideColor: backSideKey
      });
    }
  }
});
